module.exports = __webpack_public_path__ + "img/screenshot3-phone.96b1056d.jpg";